import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const ConnectIconMedium: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.51243 19.4847C7.02486 21.8775 10.0159 20.9204 11.2123 19.9513C11.8313 19.4499 12.1096 19.1258 12.3488 18.8865C13.1863 18.1088 13.1325 17.3312 12.5881 16.7091C12.3703 16.4601 10.973 15.1179 9.63301 13.742C8.9391 13.048 8.46054 12.5576 8.05137 12.1628C7.50342 11.6166 7.02487 10.9903 6.30703 11.0082C5.64901 11.0082 5.17045 11.5885 4.57225 12.1867C3.8841 12.8748 3.37586 13.742 3.1964 14.5197C2.65802 16.7928 3.4955 18.4079 4.51243 19.4847ZM4.51243 19.4847L2 21.9971"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M19.487 4.51362C16.9739 2.11968 13.9932 3.09483 12.7965 4.06438C12.1773 4.56602 11.899 4.89028 11.6596 5.12968C10.8219 5.90771 10.8758 6.68573 11.4203 7.30816C11.4986 7.39771 11.7295 7.62865 12.0553 7.95171M19.487 4.51362C20.5043 5.59089 21.3531 7.22437 20.8145 9.49861C20.635 10.2766 20.1267 11.1442 19.4383 11.8327C18.84 12.4312 18.3613 13.0117 17.7031 13.0117C16.985 13.0297 16.6124 12.5104 16.0643 11.964M19.487 4.51362L22.0002 2M12.0553 7.95171C12.6358 8.52721 13.5178 9.39502 14.3762 10.2766C15.0703 10.971 15.655 11.569 16.0643 11.964M12.0553 7.95171L10.5117 9.50499M16.0643 11.964L14.5027 13.4885"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
export const ConnectIconSmall: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.00839 12.9911C4.68334 14.5863 6.67736 13.9482 7.47496 13.3022C7.88762 12.9679 8.07316 12.7518 8.23262 12.5923C8.79096 12.0738 8.75509 11.5554 8.39215 11.1407C8.24695 10.9747 7.31542 10.0799 6.42211 9.16263C5.9595 8.69996 5.64046 8.37303 5.36768 8.10983C5.00238 7.74569 4.68335 7.32816 4.20479 7.34009C3.76611 7.34009 3.44707 7.72696 3.04827 8.12576C2.5895 8.58449 2.25068 9.16263 2.13104 9.68109C1.77212 11.1965 2.33044 12.2732 3.00839 12.9911ZM3.00839 12.9911L1.33344 14.666"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12.9912 3.00985C11.3158 1.41389 9.32863 2.06399 8.53083 2.71036C8.11803 3.04479 7.9325 3.26096 7.7729 3.42056C7.21443 3.93925 7.25036 4.45793 7.61336 4.87288C7.66556 4.93258 7.8195 5.08654 8.0367 5.30191M12.9912 3.00985C13.6694 3.72803 14.2352 4.81702 13.8762 6.33318C13.7565 6.85184 13.4176 7.43024 12.9587 7.88924C12.5598 8.28824 12.2407 8.67524 11.8019 8.67524C11.3232 8.68724 11.0748 8.34104 10.7094 7.97677M12.9912 3.00985L14.6666 1.33411M8.0367 5.30191C8.4237 5.68558 9.0117 6.26412 9.58396 6.85184C10.0467 7.31477 10.4365 7.71344 10.7094 7.97677M8.0367 5.30191L7.00763 6.33743M10.7094 7.97677L9.6683 8.99311"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
